import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getFacilityKind } from "../helpers/cookies";
import { PATHS } from "../constants/paths";
import { ROLES } from "../constants/roles";

/** Paths only for independent yoga studios (facilityKind=yoga_studio). */
const STUDIO_ONLY_PATHS = [PATHS.YOGA_BUSINESS_DASHBOARD, PATHS.YOGA_FINANCES];

/** Path prefixes only for hospital-internal yoga (facilityKind=hospital). */
const HOSPITAL_ONLY_PREFIXES = [PATHS.YOGA_IN_PATIENT_DEPT];

const pathMatches = (pathname, base) =>
  pathname === base || pathname.startsWith(`${base}/`);

/**
 * Redirects yoga_instructor users away from menu items not allowed
 * for their hospital/studio facility kind.
 */
const YogaFacilityGuard = ({ children }) => {
  const location = useLocation();
  const facilityKind = getFacilityKind();
  const pathname = location.pathname;

  const userRole = localStorage.getItem("user_role");
  if (userRole === "admin" || userRole === ROLES.ADMIN) {
    return children;
  }

  if (facilityKind !== "yoga_studio") {
    if (STUDIO_ONLY_PATHS.some((p) => pathMatches(pathname, p))) {
      return <Navigate to={PATHS.YOGA_DASHBOARD} replace />;
    }
  }

  if (facilityKind === "yoga_studio") {
    if (HOSPITAL_ONLY_PREFIXES.some((p) => pathMatches(pathname, p))) {
      return <Navigate to={PATHS.YOGA_DASHBOARD} replace />;
    }
  }

  return children;
};

export default YogaFacilityGuard;
